// AUTO-GENERATED chunk 'auth-handlers' by build_bundle.py
// Modules: auth-handlers.js

// ═══ auth-handlers.js ═══
;"use strict";
// @ts-nocheck
// §AUTH-HANDLERS ═══════════════════════════════════════════════════════════════
//
// NH9 step 2 (2026-05-07): extracted from milestones-view.ts so the auth
// pill (open/close modal, sign-in, register, session check, sign-out,
// OAuth, Terms re-acceptance, age-gate) can be loaded as a STANDALONE
// pre-bundle defer script — independent of bundle-app's parse cost.
//
// R1 mitigation (per docs/plans/NH9_BUNDLE_APP_SPLIT_BOOT_AUDIT.md §6.1):
// the ≤1.5 s functional contract for the auth pill cannot tolerate the
// ~600 KB bundle-app parse blocking. By re-homing the auth code into its
// own ~12 KB chunk that loads BEFORE bundle-app via a dedicated <script
// defer> tag (dashboard.html), the auth modal is interactive on first
// click even on slow networks where bundle-app is still in flight.
//
// LOAD-ORDER INVARIANT
// --------------------
// auth-handlers loads as a separate <script defer> tag positioned AFTER
// tier-fallback.generated.js but BEFORE bundle-app.min.js. All globals
// it declares (var _authUser, var _csrfTokenCache, var _oauthConfig,
// function authToggle, function authOpenModal, function authCheckSession,
// function _getCsrfToken, function _setCsrfToken, function _csrfHeaders,
// etc.) become window-scoped and are visible to bundle-app modules at
// their parse time. Other TS modules already access them via:
//   typeof _getCsrfToken === 'function' ? _getCsrfToken() : ''
// or via globals.d.ts ambient declarations — no consumer change needed.
//
// PURE EXTRACTION
// ---------------
// No logic changes vs the prior milestones-view.ts:1316-2388 block.
// Future tightening lands in PRs 63-65 strict cleanup; the // @ts-nocheck
// stays in place until then.
//
// SCOPE OF MOVED CODE
// -------------------
//   - authGate, authToggle, authOpenModal, authCloseModal, authCloseDropdown
//   - authSwitchTab, authToggleMode, authTogglePasswordVisibility
//   - _csrfTokenCache + _getCsrfToken + _setCsrfToken + _csrfHeaders
//   - authSubmitSignin (incl. CR-H9 verify-resend link)
//   - OAuth: _oauthConfig, _loadOAuthConfig, authSignInGoogle, authSignInGitHub,
//     _completeOAuthSignIn, _checkOAuthCallback (+ on-load _loadOAuthConfig()
//     and _checkOAuthCallback() calls)
//   - _setupAgeGateListener (COUNSEL-C5 age gate on auth-reg-dob)
//   - authSubmitRegister (incl. PoW progress widget)
//   - authSignOut (incl. CR-C3 ol_-prefix purge + sessionStorage clear)
//   - _serverSyncDone + _syncPortfolioTickersFromServer + _syncNotesFromServer
//     (called from authUpdateUI; auth-state lifecycle even though they touch
//     PORTFOLIO_TICKERS / scratchpad — guarded with typeof checks)
//   - authUpdateUI
//   - _authMeFetchSafe + authCheckSession (b74549eb defensive shim retained)
//   - _showTermsReacceptanceModal + _escHtmlTerms (ROADMAP P2 modal; only
//     fired from authCheckSession, so re-homed alongside)
//   - Outside-click handler for #auth-dropdown
//   - Overlay click handler for #auth-modal-overlay
//   - Top-level authCheckSession() + setInterval re-check
//   - Billing redirect query-param handler IIFE (signin=1, billing=success/cancel)
//
// LEFT IN MILESTONES-VIEW.TS
// --------------------------
//   - All non-auth code (milestones renderer, achievements, usage panel,
//     EPS surprise tables, recommendation trends, LEARN mastery integration).
// ═══════════════════════════════════════════════════════════════════════════════
// ═══ AUTH: LOGIN / REGISTER / SESSION ═══
var _authUser = null; // { email, displayName, createdAt } or null
// Progressive access: gate save/persist actions, not page views
function authGate(actionName) {
    if (_authUser)
        return true; // logged in, proceed
    // OWNER 2026-10-03: a browser that answered "Under 13" is never invited to
    // make an account (the helper lives in theme-init.ts / theme-bootstrap.ts).
    if (typeof olIsUnder13Browser === 'function' && olIsUnder13Browser())
        return false;
    // Show registration modal with context message
    if (typeof authOpenModal === 'function')
        authOpenModal('register');
    if (typeof showToast === 'function')
        showToast('Create a free account to ' + (actionName || 'save your work'), '', 4000);
    return false; // caller should abort the action
}
function authToggle() {
    if (_authUser) {
        // Logged in — toggle dropdown
        const dd = document.getElementById('auth-dropdown');
        dd.classList.toggle('open');
        // Render value score widget when opening
        if (dd.classList.contains('open') && typeof renderValueScoreWidget === 'function') {
            renderValueScoreWidget();
        }
    }
    else {
        // Not logged in — open modal
        authOpenModal();
    }
}
var _authFocusTrapCleanup = null;
var _authTriggerEl = null;
// `mode` param accepts 'signin' (default) or 'register'. 2026-04-26 hotfix:
// previous implementation hardcoded authSwitchTab('signin'), so callers like
// welcome-signup and the Settings-panel "Create account" button (which pass
// 'register') would all land on the sign-in tab. Now respects the param and
// the focus target follows the active tab so the first field is the right one.
function authOpenModal(mode) {
    // OWNER 2026-10-03: the sign-in / register modal does not open for a browser
    // that answered "Under 13" on the age bar. Every opener lands here (topbar,
    // ?signup=1, premium gates, Ask AI, watchlist), so this one check closes
    // them all; the OAuth buttons on the sign-in tab create accounts too, which
    // is why both modes are refused.
    if (typeof olIsUnder13Browser === 'function' && olIsUnder13Browser()) {
        if (typeof showToast === 'function')
            showToast('Oxford Ledge is for people 13 and older.', '', 4000);
        return;
    }
    var _mode = (mode === 'register') ? 'register' : 'signin';
    _materializeView('auth-modal-overlay').then(function () {
        _authTriggerEl = document.activeElement;
        const ov = document.getElementById('auth-modal-overlay');
        if (!ov)
            return;
        ov.classList.add('open');
        authSwitchTab(_mode);
        // Clear errors
        document.getElementById('auth-err-signin')?.classList.remove('visible');
        document.getElementById('auth-err-register')?.classList.remove('visible');
        // Activate focus trap (B-29)
        if (typeof trapFocus === 'function')
            _authFocusTrapCleanup = trapFocus(ov);
        // Set DOB max to today (dynamic, not hardcoded)
        var _dobInput = document.getElementById('auth-reg-dob');
        if (_dobInput)
            _dobInput.max = new Date().toISOString().slice(0, 10);
        // Focus first field of whichever form is active
        var _focusId = (_mode === 'register') ? 'auth-reg-email' : 'auth-signin-email';
        setTimeout(function () { document.getElementById(_focusId)?.focus(); }, 100);
    });
}
function authCloseModal() {
    document.getElementById('auth-modal-overlay')?.classList.remove('open');
    if (_authFocusTrapCleanup) {
        _authFocusTrapCleanup();
        _authFocusTrapCleanup = null;
    }
    // Return focus to trigger element
    if (_authTriggerEl) {
        try {
            _authTriggerEl.focus();
        }
        catch (e) { }
        _authTriggerEl = null;
    }
}
function authCloseDropdown() {
    document.getElementById('auth-dropdown')?.classList.remove('open');
}
var _authCurrentMode = 'signin';
function authSwitchTab(tab) {
    var _prevMode = _authCurrentMode;
    _authCurrentMode = tab;
    document.getElementById('auth-form-signin')?.classList.toggle('active', tab === 'signin');
    document.getElementById('auth-form-register')?.classList.toggle('active', tab === 'register');
    // S4 (2026-09-25): the password-reset pane is a third tab. Opened only by
    // the "Forgot password?" link on the sign-in form (authOpenForgot); the
    // mode toggle below takes the user back to sign-in from it.
    document.getElementById('auth-form-forgot')?.classList.toggle('active', tab === 'forgot');
    // S2 (mobile audit 2026-09-25): the "Check your inbox" pane after an email
    // sign-up is a fourth tab. The sign-in buttons above it are hidden while it
    // shows (a reader who just signed up is not choosing a provider), and come
    // back on any other tab; `d-none` is used because the OAuth config owns the
    // `hidden` class on the same element.
    document.getElementById('auth-form-inbox')?.classList.toggle('active', tab === 'inbox');
    document.getElementById('auth-oauth-buttons')?.classList.toggle('d-none', tab === 'inbox');
    // The divider is d-none until the email form is revealed, so it is only
    // restored when LEAVING the inbox pane (the form was open to get there).
    if (tab === 'inbox')
        document.querySelector('.auth-oauth-divider')?.classList.add('d-none');
    else if (_prevMode === 'inbox')
        document.querySelector('.auth-oauth-divider')?.classList.remove('d-none');
    if (tab === 'inbox') {
        var _iSubtitle = document.querySelector('.auth-brand-subtitle');
        if (_iSubtitle)
            _iSubtitle.textContent = 'Check your inbox.';
        var _iToggleText = document.getElementById('auth-toggle-text');
        var _iToggleBtn = document.getElementById('auth-toggle-btn');
        if (_iToggleText && _iToggleBtn) {
            _iToggleText.textContent = 'Already confirmed your email?';
            _iToggleBtn.textContent = 'Sign in';
        }
        document.getElementById('auth-err-register')?.classList.remove('visible');
        return;
    }
    if (tab === 'forgot') {
        var _fSubtitle = document.querySelector('.auth-brand-subtitle');
        if (_fSubtitle)
            _fSubtitle.textContent = 'Reset your password.';
        var _fToggleText = document.getElementById('auth-toggle-text');
        var _fToggleBtn = document.getElementById('auth-toggle-btn');
        if (_fToggleText && _fToggleBtn) {
            _fToggleText.textContent = 'Remembered it?';
            _fToggleBtn.textContent = 'Back to sign in';
        }
        document.getElementById('auth-err-signin')?.classList.remove('visible');
        document.getElementById('auth-err-register')?.classList.remove('visible');
        document.getElementById('auth-err-forgot')?.classList.remove('visible');
        return;
    }
    // 2026-06-02 (OWNER browser-pass): a new user couldn't tell whether they were
    // signing in or creating an account for the first time. Mirror the MODE in the
    // prominent brand subtitle (the toggle link alone was too subtle) + the email-
    // fallback CTA, so the modal's purpose is unmistakable. OAuth buttons stay
    // "Continue with …" (mode-agnostic — Google/GitHub register-or-login the same).
    var subtitle = document.querySelector('.auth-brand-subtitle');
    if (subtitle) {
        subtitle.textContent = (tab === 'register')
            ? 'Create your free account — save research, build watchlists, and follow filings.'
            : 'Sign in to save research, build watchlists, and follow filings.';
    }
    var emailFallback = document.querySelector('[data-action="auth-show-email-fallback"]');
    if (emailFallback) {
        emailFallback.textContent = (tab === 'register') ? 'Sign up with email' : 'Sign in with email';
    }
    // Update toggle link text
    var toggleText = document.getElementById('auth-toggle-text');
    var toggleBtn = document.getElementById('auth-toggle-btn');
    if (toggleText && toggleBtn) {
        if (tab === 'signin') {
            toggleText.textContent = "Don't have an account?";
            toggleBtn.textContent = 'Create one';
        }
        else {
            toggleText.textContent = 'Already have an account?';
            toggleBtn.textContent = 'Sign in';
        }
    }
    // Clear errors on switch
    document.getElementById('auth-err-signin')?.classList.remove('visible');
    document.getElementById('auth-err-register')?.classList.remove('visible');
}
function authToggleMode() {
    // Only sign-in flips to register; from register, the reset pane ("Back to
    // sign in") and the inbox pane ("Sign in", 2026-09-25) it means sign-in.
    authSwitchTab(_authCurrentMode === 'signin' ? 'register' : 'signin');
}
function authTogglePasswordVisibility(btn) {
    var wrap = btn.closest('.auth-password-wrap');
    if (!wrap)
        return;
    var input = wrap.querySelector('input');
    var eyeOpen = btn.querySelector('.auth-pw-eye-open');
    var eyeClosed = btn.querySelector('.auth-pw-eye-closed');
    if (input.type === 'password') {
        input.type = 'text';
        if (eyeOpen) {
            eyeOpen.classList.add('d-none');
            eyeOpen.classList.remove('d-block');
        }
        if (eyeClosed) {
            eyeClosed.classList.remove('d-none');
            eyeClosed.classList.add('d-block');
        }
        btn.setAttribute('aria-label', 'Hide password');
    }
    else {
        input.type = 'password';
        if (eyeOpen) {
            eyeOpen.classList.remove('d-none');
            eyeOpen.classList.add('d-block');
        }
        if (eyeClosed) {
            eyeClosed.classList.add('d-none');
            eyeClosed.classList.remove('d-block');
        }
        btn.setAttribute('aria-label', 'Show password');
    }
}
// ── CSRF Token helpers ──
// CSRF cookie is now HttpOnly — JS reads token from auth/me or login response
var _csrfTokenCache = '';
function _getCsrfToken() {
    // #60 / H-4: prefer the server-derived HMAC — the JS-readable `ol_csrf_hmac`
    // cookie holds HMAC(ol_session), which is exactly what validate_csrf path (b)
    // expects. That path never reads the legacy `ol_csrf` cookie, so sending the
    // HMAC is immune to BOTH a stale `_csrfTokenCache` AND the dual/stale `ol_csrf`
    // cookie (apex + host-only `www` leftover) that was 403'ing state-changing
    // POSTs (e.g. the billing portal). Falls back to the cached token for anon
    // flows / pre-H-4 sessions / dev without OL_CSRF_SECRET (path (a)). This is
    // the "auth-handlers shim that prefers the HMAC value" _set_auth_cookies
    // already documents but which was never wired here.
    try {
        var m = document.cookie.match(/(^|;)\s*ol_csrf_hmac=([^;]+)/);
        if (m && m[2])
            return decodeURIComponent(m[2]);
    }
    catch (_e) { /* document.cookie unavailable — fall through to cache */ }
    return _csrfTokenCache || '';
}
function _setCsrfToken(token) {
    _csrfTokenCache = token || '';
}
function _csrfHeaders() {
    return { 'Content-Type': 'application/json', 'X-CSRF-Token': _getCsrfToken() };
}
// ── Marketing→app deep-link continuity (PH-1) ──
// Capture the current path+query as a `next` redirect-back hint so a user
// who signs up from /pricing/ or /features/ lands back where they started
// after verify-email. Strips auth-modal own params so the URL doesn't
// echo back ?signup=1 / ?auth=verified noise. Backend revalidates via
// `_safe_next_url` so this can never be an open-redirect vector.
//
// S7 (mobile/tablet audit 2026-09-25): an in-lesson signup nudge links to
// `/?signup=1&next=<lesson path>`, and the server already honours `next`
// (routes_auth_fastapi.py register + login). But this function read the
// CURRENT URL at submit time -- by then it is `/` (the modal openers strip
// the query with history.replaceState before the user types a letter), so
// the lesson path was lost. Now a `next` on the page URL wins, same-origin
// path only (starts with `/`, not `//`, no `://`; the server re-validates via
// `_safe_next_url`). It is read ONCE at load, before any opener strips it,
// and held in `_authNextHint`; the current URL is the fallback exactly as
// before. Pinned by tests/test_auth_capture_next_url_contract.py.
function _safeNextPath(value) {
    if (!value)
        return '';
    var v = String(value).trim();
    if (!v || v.length > 512)
        return '';
    if (v.charAt(0) !== '/')
        return '';
    if (v.charAt(1) === '/')
        return '';
    if (v.indexOf('://') !== -1)
        return '';
    // Browsers delete tab/CR/LF from URLs, so '/\t/evil.com' navigates to
    // '//evil.com'; a backslash is read as '/'. Reject both anywhere, not only
    // at index 1 (CHAOS 2026-09-25 novice-flow review, mirrors _safe_next_url).
    // eslint-disable-next-line no-control-regex -- the control range IS the check
    if (/[\u0000-\u001f\u007f\\]/.test(v))
        return '';
    return v;
}
function _readNextHint() {
    try {
        return _safeNextPath(new URLSearchParams(window.location.search || '').get('next'));
    }
    catch (_e) {
        return '';
    }
}
var _authNextHint = _readNextHint();
function _captureNextUrl() {
    try {
        const hinted = _authNextHint || _readNextHint();
        if (hinted)
            return hinted;
        const path = window.location.pathname || '/';
        const params = new URLSearchParams(window.location.search || '');
        ['signup', 'auth', 'walkthrough', 'next'].forEach(function (k) { params.delete(k); });
        const qs = params.toString();
        return qs ? path + '?' + qs : path;
    }
    catch (_e) {
        return '/';
    }
}
async function authSubmitSignin(e) {
    e.preventDefault();
    const btn = document.getElementById('auth-signin-btn');
    const errEl = document.getElementById('auth-err-signin');
    const email = (document.getElementById('auth-signin-email')?.value || '').trim();
    const password = document.getElementById('auth-signin-pass')?.value || '';
    if (!email || !password) {
        if (errEl) {
            errEl.textContent = 'Email and password required';
            errEl.classList.add('visible');
        }
        return;
    }
    if (btn) {
        btn.disabled = true;
        btn.textContent = 'Signing in…';
    }
    if (errEl)
        errEl.classList.remove('visible');
    try {
        const res = await fetch('/api/auth/login', {
            method: 'POST', headers: _csrfHeaders(),
            credentials: 'same-origin',
            body: JSON.stringify({ email, password, next: _captureNextUrl() })
        });
        const data = await res.json();
        if (!res.ok) {
            if (errEl) {
                var _msg = data.error || 'Unable to sign in. Please check your credentials and try again.';
                errEl.textContent = _msg;
                // CR-H9 (2026-05-04): when the 403 is "please verify your email", surface
                // a "Didn't get the email?" inline resend link so spam-filter victims have
                // an immediate recovery path. Posts to /api/auth/resend-verify with the
                // email the user just typed. CSS in dashboard-styles.css (.ol-resend-link*).
                if (res.status === 403 && _msg.toLowerCase().indexOf('verify') !== -1) {
                    var _wrap = document.createElement('span');
                    _wrap.className = 'ol-resend-link-wrap';
                    var _a = document.createElement('a');
                    _a.href = '#';
                    _a.className = 'ol-resend-link';
                    _a.textContent = "Didn't get the email? Resend verification";
                    _a.setAttribute('aria-label', 'Resend verification email');
                    _a.addEventListener('click', function (ev) {
                        ev.preventDefault();
                        _a.textContent = 'Sending…';
                        _a.classList.add('ol-resend-link--pending');
                        fetch('/api/auth/resend-verify', {
                            method: 'POST',
                            headers: _csrfHeaders(),
                            credentials: 'same-origin',
                            body: JSON.stringify({ email: email }),
                        })
                            .then(function (r) { return r.json().catch(function () { return {}; }); })
                            .then(function () {
                            _a.textContent = 'Sent — check your inbox';
                            _a.classList.add('ol-resend-link--done');
                        })
                            .catch(function () {
                            _a.textContent = 'Try again in a moment';
                            _a.classList.remove('ol-resend-link--pending');
                        });
                    });
                    _wrap.appendChild(_a);
                    errEl.appendChild(_wrap);
                }
                errEl.classList.add('visible');
            }
            return;
        }
        if (data.csrf_token)
            _setCsrfToken(data.csrf_token);
        if (data.tier)
            window._userTier = data.tier;
        if (data.trial_active)
            window._trialActive = true;
        _authUser = data.user || data;
        // #23 (audit 2026-06-18): auth state just changed server-side — drop the
        // getAuthMe cache so other modules re-fetch the authed state, not a <=5s
        // stale anon snapshot.
        try {
            window.OLApi?._invalidateAuthMe?.();
        }
        catch (_e) { }
        authUpdateUI();
        authCloseModal();
        showToast('Signed in as ' + escHtml(_authUser.displayName || _authUser.email), 'success', 3000);
        // Deep-link continuity (PH-1): if backend echoed back a validated
        // `next` path, navigate there so a user signing in from /pricing/
        // lands back on /pricing/ in the authed state (rather than wherever
        // app.ts default-routes to). Backend validates same-origin; FE
        // requires startsWith('/') as a defense-in-depth strip.
        try {
            var nextPath = data && typeof data.next === 'string' ? data.next : '';
            var here = window.location.pathname + window.location.search;
            if (nextPath && nextPath.charAt(0) === '/' && nextPath !== here) {
                window.location.href = nextPath;
            }
        }
        catch (_navErr) { /* stay on current page */ }
    }
    catch (err) {
        if (errEl) {
            errEl.textContent = 'Unable to connect. Check your connection and try again.';
            errEl.classList.add('visible');
        }
    }
    finally {
        if (btn) {
            btn.disabled = false;
            btn.textContent = 'Sign In';
        }
    }
}
// ── OAuth Sign-In ──
var _oauthConfig = null;
var _oauthConfigInflight = null;
async function _loadOAuthConfig() {
    const MAX_RETRIES = 2;
    const RETRY_DELAY_MS = 2000;
    // #188 429-cascade fix (2026-05-24): oauth-config is STATIC per session, so
    // fetch it at most once and share the in-flight promise across concurrent
    // callers (auth-handlers on-load + app-init). Previously every call re-ran
    // the fetch, and a 429 triggered up to 3 retries — multiplied across callers
    // this storms the shared cold-start per-IP rate bucket and starves
    // /api/auth/me, leaving the portfolio stuck "Loading…" until the window
    // resets. (The endpoint is now also rate-limit-exempt server-side; this
    // client cache is the belt to that suspenders.)
    if (!_oauthConfig) {
        if (!_oauthConfigInflight) {
            _oauthConfigInflight = (async () => {
                for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
                    try {
                        if (attempt > 0)
                            await new Promise(r => setTimeout(r, RETRY_DELAY_MS));
                        const res = await fetch('/api/auth/oauth-config');
                        // A 429 means "back off" — retrying AMPLIFIES the cascade. Stop and
                        // fail-open (buttons stay visible; the server handles auth errors).
                        if (res.status === 429)
                            return;
                        if (!res.ok)
                            continue; // transient 5xx / network — retry
                        _oauthConfig = await res.json();
                        return;
                    }
                    catch (_e) { /* network error — retry */ }
                }
            })();
        }
        try {
            await _oauthConfigInflight;
        }
        finally {
            _oauthConfigInflight = null;
        }
    }
    const oauthBtns = document.getElementById('auth-oauth-buttons');
    if (!oauthBtns)
        return;
    // If config never loaded, leave buttons visible (fail-open) so OAuth
    // redirects can still work — the server handles auth errors gracefully.
    if (!_oauthConfig)
        return;
    const googleEnabled = _oauthConfig.google && _oauthConfig.google.enabled;
    const githubEnabled = _oauthConfig.github && _oauthConfig.github.enabled;
    // Only hide buttons if the config explicitly says BOTH are disabled
    if (!googleEnabled && !githubEnabled) {
        oauthBtns.classList.add('hidden');
        return;
    }
    // Hide individual buttons if that specific provider is not configured
    if (!googleEnabled) {
        const _gBtn = document.getElementById('auth-btn-google');
        if (_gBtn)
            _gBtn.classList.add('hidden');
    }
    if (!githubEnabled) {
        const _ghBtn = document.getElementById('auth-btn-github');
        if (_ghBtn)
            _ghBtn.classList.add('hidden');
    }
    // Google OAuth: no GSI library needed — uses server-side authorization code flow
}
async function authSignInGoogle() {
    if (!_oauthConfig || !_oauthConfig.google || !_oauthConfig.google.enabled) {
        showToast('Unable to load Google sign-in. Please try again shortly.', 'error', 4000);
        return;
    }
    var btn = document.getElementById('auth-btn-google');
    if (btn)
        btn.disabled = true;
    try {
        // Fetch CSRF state token from server (same pattern as GitHub)
        var stateRes = await fetch('/api/auth/oauth-state?provider=google', { credentials: 'same-origin' });
        var stateData = await stateRes.json();
        var state = stateData.state || '';
        if (!state) {
            showToast('Unable to initialize Google sign-in.', 'error');
            if (btn)
                btn.disabled = false;
            return;
        }
        var clientId = _oauthConfig.google.client_id;
        var redirectUri = window.location.origin + '/auth/google/callback';
        // #152 (2026-06-09): remember where the user was so the OAuth callback
        // can return them here instead of dumping them on the default AAPL
        // dashboard. sessionStorage survives the same-tab round-trip to Google.
        try {
            OLStorage.setSessionString('ol_oauth_return', window.location.pathname + window.location.search);
        }
        catch (_e) { /* private mode */ }
        window.location.href = 'https://accounts.google.com/o/oauth2/v2/auth?' +
            'client_id=' + encodeURIComponent(clientId) +
            '&redirect_uri=' + encodeURIComponent(redirectUri) +
            '&response_type=code' +
            '&scope=openid%20email%20profile' +
            '&state=' + encodeURIComponent(state) +
            '&access_type=online';
    }
    catch (e) {
        showToast('Google sign-in failed. Please try again.', 'error');
        if (btn)
            btn.disabled = false;
    }
}
async function authSignInGitHub() {
    if (!_oauthConfig || !_oauthConfig.github || !_oauthConfig.github.enabled) {
        showToast('Unable to load GitHub sign-in. Please try again shortly.', 'error', 4000);
        return;
    }
    const btn = document.getElementById('auth-btn-github');
    btn.disabled = true;
    try {
        // Fetch CSRF state token from server to prevent OAuth CSRF attacks
        const stateRes = await fetch('/api/auth/oauth-state?provider=github', { credentials: 'same-origin' });
        const stateData = await stateRes.json();
        const state = stateData.state || '';
        if (!state) {
            showToast('Unable to initialize GitHub sign-in.', 'error');
            btn.disabled = false;
            return;
        }
        const clientId = _oauthConfig.github.client_id;
        const redirectUri = window.location.origin + '/auth/github/callback';
        // #152 (2026-06-09): see google handler — preserve pre-auth location.
        try {
            OLStorage.setSessionString('ol_oauth_return', window.location.pathname + window.location.search);
        }
        catch (_e) { /* private mode */ }
        window.location.href = 'https://github.com/login/oauth/authorize?' +
            'client_id=' + encodeURIComponent(clientId) +
            '&redirect_uri=' + encodeURIComponent(redirectUri) +
            '&scope=user:email' +
            '&state=' + encodeURIComponent(state);
    }
    catch (e) {
        showToast('GitHub sign-in failed. Please try again.', 'error');
        btn.disabled = false;
    }
}
async function _completeOAuthSignIn(endpoint, payload) {
    const errEl = document.getElementById('auth-err-signin');
    try {
        const res = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify(payload),
        });
        const data = await res.json();
        if (!res.ok) {
            if (errEl) {
                errEl.textContent = data.error || 'Unable to complete sign-in. Please try again.';
                errEl.classList.add('visible');
            }
            return;
        }
        if (data.csrf_token)
            _setCsrfToken(data.csrf_token);
        _authUser = data.user || data;
        authUpdateUI();
        authCloseModal();
        showToast('Signed in as ' + escHtml(_authUser.display_name || _authUser.email), 'success', 3000);
    }
    catch (err) {
        if (errEl) {
            errEl.textContent = 'Unable to connect. Check your connection and try again.';
            errEl.classList.add('visible');
        }
    }
}
// Handle GitHub OAuth redirect callback (SEC-03: code exchanged server-side, only status in URL)
function _checkOAuthCallback() {
    var params = new URLSearchParams(window.location.search);
    var authStatus = params.get('auth');
    var reason = params.get('reason');
    if (authStatus) {
        // #152 (2026-06-09): default to stripping the query (tidy URL), but on a
        // successful sign-in restore the pre-auth location saved at OAuth-init so
        // the SPA boots back into the view the user came from (e.g. /?view=bdc)
        // instead of the default AAPL dashboard. Same-origin path only (open-
        // redirect guard: single leading '/', reject '//' and '://').
        var _dest = window.location.pathname;
        if (authStatus === 'success') {
            try {
                // typeof guard: _checkOAuthCallback runs at module top-level and can
                // race ahead of storage.ts's OLStorage registration (the classic
                // module-top global race) — degrade to the bare-pathname strip if so.
                var _ret = (typeof OLStorage !== 'undefined') ? OLStorage.getSessionString('ol_oauth_return', null) : null;
                if (typeof OLStorage !== 'undefined')
                    OLStorage.removeSession('ol_oauth_return');
                if (_ret && _ret.charAt(0) === '/' && _ret.charAt(1) !== '/' && _ret.indexOf('://') === -1) {
                    _dest = _ret;
                }
            }
            catch (_e) { /* storage blocked — fall back to bare pathname */ }
        }
        window.history.replaceState({}, document.title, _dest);
        if (authStatus === 'success') {
            // Session cookie was set server-side during the redirect — just fetch user info
            authCheckSession();
            // Defensive guard — _checkOAuthCallback fires at module top-level (line 405),
            // which can race ahead of the toast module's window-global registration.
            // Pattern: feedback_module_top_level_global_race memory. Incident:
            // GitHub OAuth callback 2026-05-11 — sign-in succeeded but the toast
            // threw ReferenceError, breaking the success-confirmation UX.
            if (typeof showToast === 'function')
                showToast('Signed in successfully', 'success', 3000);
        }
        else if (authStatus === 'error') {
            var msg = reason === 'google_denied' ? 'Google sign-in was cancelled.' :
                reason === 'google_failed' ? 'Google sign-in failed. Please try again.' :
                    reason === 'github_failed' ? 'GitHub sign-in failed. Please try again.' :
                        'Sign-in failed. Please try again.';
            if (typeof showToast === 'function')
                showToast(msg, 'error', 5000);
        }
    }
}
// Initialize OAuth on page load
_loadOAuthConfig();
_checkOAuthCallback();
// COUNSEL-C5: Age gate — check DOB via server and show/hide parental consent
function _setupAgeGateListener() {
    var dobEl = document.getElementById('auth-reg-dob');
    if (!dobEl)
        return;
    var _ageDebounce = null;
    dobEl.addEventListener('change', function () {
        clearTimeout(_ageDebounce);
        var dob = dobEl.value;
        var msgEl = document.getElementById('auth-age-gate-msg');
        var parentWrap = document.getElementById('auth-parental-consent-wrap');
        var regBtn = document.getElementById('auth-reg-btn');
        if (!dob) {
            msgEl?.classList.add('d-none');
            parentWrap?.classList.add('d-none');
            regBtn && (regBtn.disabled = false);
            return;
        }
        _ageDebounce = setTimeout(function () {
            fetch('/api/auth/age-check?dob=' + encodeURIComponent(dob))
                .then(function (r) { if (!r.ok)
                throw new Error('HTTP ' + r.status); return r.json(); })
                .then(function (data) {
                if (data.error) {
                    msgEl.textContent = data.error;
                    msgEl.className = 'auth-age-gate-msg auth-age-gate-error';
                    return;
                }
                if (data.blocked) {
                    msgEl.textContent = 'You must be 13 or older to use this platform.';
                    msgEl.className = 'auth-age-gate-msg auth-age-gate-error';
                    parentWrap?.classList.add('d-none');
                    regBtn && (regBtn.disabled = true);
                }
                else if (data.consent_required) {
                    msgEl.textContent = 'Users under 18 require parental consent.';
                    msgEl.className = 'auth-age-gate-msg auth-age-gate-warn';
                    parentWrap?.classList.remove('d-none');
                    var parentInput = document.getElementById('auth-reg-parent-email');
                    if (parentInput)
                        parentInput.required = true;
                    regBtn && (regBtn.disabled = false);
                }
                else {
                    msgEl.textContent = '';
                    msgEl.className = 'auth-age-gate-msg d-none';
                    parentWrap?.classList.add('d-none');
                    var parentInput2 = document.getElementById('auth-reg-parent-email');
                    if (parentInput2) {
                        parentInput2.required = false;
                        parentInput2.value = '';
                    }
                    regBtn && (regBtn.disabled = false);
                }
            })
                .catch(function () { msgEl.textContent = ''; msgEl.className = 'auth-age-gate-msg d-none'; });
        }, 300);
    });
}
_setupAgeGateListener();
async function authSubmitRegister(e) {
    e.preventDefault();
    const btn = document.getElementById('auth-reg-btn');
    const errEl = document.getElementById('auth-err-register');
    const displayName = (document.getElementById('auth-reg-name')?.value || '').trim();
    const email = (document.getElementById('auth-reg-email')?.value || '').trim();
    const password = document.getElementById('auth-reg-pass')?.value || '';
    const dateOfBirth = (document.getElementById('auth-reg-dob')?.value || '').trim();
    const parentalConsentEmail = (document.getElementById('auth-reg-parent-email')?.value || '').trim();
    // NM4 (2026-05-07): per-field validation messages instead of the
    // generic "All fields are required" — users can't tell which field
    // they missed. Now: name the specific field + focus it so the
    // user knows where to fix.
    if (!displayName) {
        if (errEl) {
            errEl.textContent = 'Display name is required.';
            errEl.classList.add('visible');
        }
        document.getElementById('auth-reg-name')?.focus();
        return;
    }
    if (!email) {
        if (errEl) {
            errEl.textContent = 'Email is required.';
            errEl.classList.add('visible');
        }
        document.getElementById('auth-reg-email')?.focus();
        return;
    }
    if (!password) {
        if (errEl) {
            errEl.textContent = 'Password is required.';
            errEl.classList.add('visible');
        }
        document.getElementById('auth-reg-pass')?.focus();
        return;
    }
    if (!dateOfBirth) {
        // S8 (2026-09-25): plain words. The old line named COPPA and the
        // retirement lessons -- jargon to a first-time user; the WHY now lives in
        // the modal's DOB hint (auth-modal-overlay.html) and this line only asks.
        if (errEl) {
            errEl.textContent = 'Please enter your date of birth.';
            errEl.classList.add('visible');
        }
        document.getElementById('auth-reg-dob')?.focus();
        return;
    }
    if (password.length < 8) {
        if (errEl) {
            errEl.textContent = 'Password must be at least 8 characters.';
            errEl.classList.add('visible');
        }
        document.getElementById('auth-reg-pass')?.focus();
        return;
    }
    if (btn) {
        btn.disabled = true;
        btn.textContent = 'Verifying…';
    }
    if (errEl)
        errEl.classList.remove('visible');
    try {
        // Step 1: Fetch proof-of-work challenge
        var challengeRes = await fetch('/api/auth/challenge', { credentials: 'same-origin' });
        if (!challengeRes.ok) {
            if (errEl) {
                errEl.textContent = 'Unable to start registration. Try again.';
                errEl.classList.add('visible');
            }
            return;
        }
        var challengeData = await challengeRes.json();
        var challenge = challengeData.challenge;
        if (!challenge) {
            if (errEl) {
                errEl.textContent = 'Registration service unavailable.';
                errEl.classList.add('visible');
            }
            return;
        }
        if (challengeData.csrf_token)
            _setCsrfToken(challengeData.csrf_token);
        // Step 2: Solve PoW — find nonce where SHA-256(challenge + nonce) starts with "000"
        // 6.3b (OWNER ratified 2026-06-12, option b): difficulty 4 → 3 hex
        // zeros (~65k → ~4k avg hashes, <1s even on slow mobile). The server
        // check (routes_auth_fastapi.py register handler) relaxed in the
        // SAME commit — a 3-zero solution FAILS a 4-zero server, so these
        // two literals must always move together (server-first is the safe
        // deploy order: a 4-zero solution also starts with "000").
        // User-sim 2026-05-06 finding #3 — Maya thought the page hung; Bob
        // worried his connection broke. Two-line fix: (a) honest button copy
        // so the user sees forward motion; (b) periodic repaint tied to a tick
        // counter (every 1000 iterations) so the browser repaints during what
        // would otherwise be a 10-30s mystery freeze on slower mobile devices.
        // Source: docs/audits/reviews/2026-05-06_user_simulation.md §3.
        // S8 (2026-09-25): the copy no longer exposes the proof-of-work counter
        // ("Verifying — N tries…" meant nothing to a first-time user). The label
        // is "Securing your account…" and the <progress> bar below carries the
        // visible motion the 2026-05-06 fix wanted; the loop still repaints the
        // bar every 1000 iterations. Pinned by
        // tests/test_auth_signup_copy_plain_language_contract.py.
        btn.textContent = 'Securing your account…';
        // PR3 (audit triage 2026-05-06): visual progress widget. The text-
        // based button copy still updates as the screen-reader fallback
        // (and for browsers without <progress>); the bar is the primary
        // affordance for sighted users.
        var _powProgressEl = document.getElementById('auth-reg-pow-progress');
        if (_powProgressEl) {
            _powProgressEl.classList.remove('hidden');
            _powProgressEl.value = 0;
        }
        var solution = null;
        var _powStartTime = Date.now();
        for (var nonce = 0; nonce < 10000000; nonce++) {
            var attempt = challenge + String(nonce);
            var hashBuf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(attempt));
            var hashHex = Array.from(new Uint8Array(hashBuf)).map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
            if (hashHex.startsWith('000')) {
                solution = String(nonce);
                break;
            }
            // Visible-progress tick. 1000 iterations is ~1s on a fast desktop
            // and ~3-4s on a slow mobile — so users see activity at least
            // every few seconds even on the worst hardware.
            if (nonce % 1000 === 0 && nonce > 0) {
                // S8: the label stays fixed; the bar is the progress readout.
                btn.textContent = 'Securing your account…';
                if (_powProgressEl) {
                    // Cap at 9500/10000 (95%) so the bar never reads "stuck at 100%"
                    // for the unlucky 5% of attempts that take longer than the
                    // calibrated max. The bar fills smoothly until cap, then holds.
                    _powProgressEl.value = Math.min(nonce, 9500);
                }
            }
        }
        if (_powProgressEl) {
            // Solution found (or loop exhausted) — fill to completion so the
            // user sees the "done" state before the next phase fires.
            _powProgressEl.value = 10000;
        }
        var _powDurationMs = Date.now() - _powStartTime;
        if (!solution) {
            if (errEl) {
                errEl.textContent = 'Verification failed. Please try again.';
                errEl.classList.add('visible');
            }
            return;
        }
        // Telemetry: track PoW duration so the OWNER can decide whether to
        // reduce difficulty for mobile UAs (user-sim §3 mitigation b). High-
        // tail durations on mobile are the signal to act on.
        try {
            if (typeof _track === 'function') {
                _track('auth_pow_duration', {
                    duration_ms: _powDurationMs,
                    tries: parseInt(solution, 10),
                    ua_mobile: /Mobi|Android|iPhone/i.test(navigator.userAgent || ''),
                });
            }
        }
        catch (_) { }
        btn.textContent = 'Creating…';
        // Step 3: Submit registration with PoW.
        // S49 CYCLE5 #2: experience/useCase/referralSource fields removed from
        // the signup form — server registration endpoint still accepts them
        // for backward-compat but we no longer collect them at signup. Intent
        // is captured post-auth via the Three Doors welcome overlay.
        // FDC 2026-04-17 T3.2: opt-in to weekly recap at signup. Daily-brief
        // stays opt-in from Settings (too frequent to default-on). Unchecked
        // by default so we never silently subscribe users to email.
        const wantWeekly = !!document.getElementById('auth-reg-email-weekly')?.checked;
        const regBody = {
            email, password, displayName, dateOfBirth,
            challenge: challenge,
            solution: solution,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
            termsAccepted: !!document.getElementById('auth-reg-terms-accept')?.checked,
            termsVersion: '2026-04-14',
            emailWeekly: wantWeekly,
            // Deep-link continuity: server appends a validated `next` query
            // param to the verify-email URL so the user lands back where they
            // started after clicking the verification link.
            next: _captureNextUrl(),
        };
        if (!regBody.termsAccepted) {
            if (errEl) {
                errEl.textContent = 'Please accept the Terms of Service and Privacy Policy to continue.';
                errEl.classList.add('visible');
            }
            if (btn) {
                btn.disabled = false;
                btn.textContent = 'Create Account';
            }
            return;
        }
        if (parentalConsentEmail)
            regBody.parentalConsentEmail = parentalConsentEmail;
        const res = await fetch('/api/auth/register', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': _getCsrfToken() },
            credentials: 'same-origin',
            body: JSON.stringify(regBody)
        });
        const data = await res.json();
        if (!res.ok) {
            if (errEl) {
                errEl.textContent = data.error || 'Registration failed';
                errEl.classList.add('visible');
            }
            return;
        }
        if (data.status === 'verify' || !data.user) {
            if (btn) {
                btn.disabled = false;
                btn.textContent = 'Create Account';
            }
            // S2 (mobile audit 2026-09-25): stay open on the "Check your inbox"
            // pane -- the address, a resend, a way back -- instead of closing
            // behind a 6-second toast a reader could miss. The toast is only the
            // fallback for a stale modal template that has no such pane.
            if (authShowCheckInbox(email))
                return;
            authCloseModal();
            showToast(data.message || 'Check your email to verify your account.', 'info', 6000);
            return;
        }
        if (data.csrf_token)
            _setCsrfToken(data.csrf_token);
        if (data.tier)
            window._userTier = data.tier;
        if (data.trial_active)
            window._trialActive = true;
        _authUser = data.user;
        // #23 (audit 2026-06-18): registration authed the user — invalidate the
        // getAuthMe cache so the next read isn't a stale anon snapshot.
        try {
            window.OLApi?._invalidateAuthMe?.();
        }
        catch (_e) { }
        // S49 CYCLE5 #2: skill-level bootstrap via registration experience
        // field is removed. The Three Doors welcome overlay now sets
        // localStorage.skillLevel based on the user's door choice, which is
        // more honest (captured in context after the user sees the product).
        authUpdateUI();
        authCloseModal();
        showToast('Welcome, ' + escHtml(_authUser.displayName || _authUser.email) + '!', 'success', 3000);
    }
    catch (err) {
        if (errEl) {
            errEl.textContent = 'Unable to connect. Check your connection and try again.';
            errEl.classList.add('visible');
        }
    }
    finally {
        if (btn) {
            btn.disabled = false;
            btn.textContent = 'Create Account';
        }
    }
}
async function authSignOut() {
    // CR-C3: Purge user-specific localStorage BEFORE the network call so that
    // even if the fetch hangs or fails the keys are gone (shared workstation /
    // kiosk defence). Never call localStorage.clear() — third-party libs
    // (Stripe, GA, Sentry) write there too. Filter to /^ol_/ + explicit list.
    try {
        // 1. Remove every key matching /^ol_/ via the OLStorage wrapper so the
        //    removal honours the same QuotaExceededError guard as writes.
        //    P1.2 retire (2026-05-04): typeof OLStorage guard + raw-localStorage
        //    fallback removed. milestones-view.js loads via bundle-app.min.js
        //    which loads AFTER storage.js (dashboard.html:187 vs 1521), so
        //    OLStorage is guaranteed defined when authSignOut runs.
        OLStorage.clearPrefix('ol_');
        // 2. Explicit purge list — legacy keys that predate the ol_ prefix
        //    convention but contain per-user state (onboarding flags, cached
        //    tickers, portfolio data, practice scores, etc.).
        var _explicitKeys = [
            'onboardingDone', 'lastTicker', 'lastView', 'lastVisitTime',
            'recentTickers', 'portfolio_tickers',
            'portfolioWeightMode', 'portfolioSortCol', 'portfolioSortDir',
            'peerColumns', 'wlSortMode', 'wlViewMode',
            'skillLevel', 'practiceHighScore', 'practiceHistory',
            'practice_fab_dismissed', 'lp_progress',
            'askai_provider', 'briefingCollapsed',
            'heroDetailsExpanded', 'mbDismissed', 'mbContent',
            'mbDetailsExpanded', 'mbFirstVisitToastShown',
            'tourCompleted', 'discoveredFeatures',
            'cookieConsent', 'buffettCtaDismissed', 'aiGlowClicks',
            '_olSessions', '_userLevel',
        ];
        for (var _ek = 0; _ek < _explicitKeys.length; _ek++) {
            try {
                OLStorage.remove(_explicitKeys[_ek]);
            }
            catch (_) { }
        }
        // 3. sessionStorage — all ol_ session state is per-session anyway;
        //    clearing it on sign-out prevents the returner-seen / upgrade-intent
        //    tokens from bleeding into the next user's session on shared devices.
        // eslint-disable-next-line ol/no-direct-localstorage -- sessionStorage has no OLStorage wrapper; full clear is the intended sign-out behavior
        try {
            window.sessionStorage.clear();
        }
        catch (_) { }
        // 4. Notify cache modules (e.g. ticker-renderer dataCache) so they can
        //    flush without knowing about the sign-out path directly.
        try {
            window.dispatchEvent(new CustomEvent('ol-user-signed-out'));
        }
        catch (_) { }
    }
    catch (_purgeErr) { }
    try {
        await fetch('/api/auth/logout', { method: 'POST', credentials: 'same-origin', headers: { 'X-CSRF-Token': _getCsrfToken() } });
    }
    catch (_) { }
    _authUser = null;
    // B-34: Clear cached data on logout (privacy on shared devices)
    if (typeof dataCache !== 'undefined') {
        for (const k in dataCache)
            delete dataCache[k];
    }
    _billingData = null;
    // Phase 1: Reset tier globals so premium-gate.js + TierGate see the
    // user as anonymous immediately (prevents stale paid-tier state
    // bleeding into the next session on shared devices).
    window._userTier = 'anonymous';
    window._trialActive = false;
    window._trialDaysRemaining = 0;
    // #23 (audit 2026-06-18): logged out — invalidate the getAuthMe cache so no
    // module serves a <=5s stale "authenticated" snapshot (shared-device safety).
    try {
        window.OLApi?._invalidateAuthMe?.();
    }
    catch (_e) { }
    try {
        window.dispatchEvent(new CustomEvent('ol-tier-changed', { detail: { tier: 'anonymous' } }));
    }
    catch (_) { }
    authUpdateUI();
    authCloseDropdown();
    showToast('Signed out', '', 2000);
}
// P2-13/P2-14: track whether we've already pulled server data for this session
var _serverSyncDone = false;
// P2-13: Fetch server-side portfolio tickers and reconcile with PORTFOLIO_TICKERS.
// Server wins when it HAS a saved list (cross-device). When the server has NONE
// (new sign-up), an anon-built local portfolio is pushed UP instead (#32).
function _syncPortfolioTickersFromServer() {
    fetch('/api/portfolio/sync-tickers', { credentials: 'include' })
        .then(function (r) { if (!r.ok)
        throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) {
        var serverTickers = data.tickers;
        if (!Array.isArray(serverTickers) || serverTickers.length === 0) {
            // #32 anon-portfolio persistence (2026-06-28, OWNER): the account has no
            // server-saved portfolio (new sign-up). If the visitor built a custom
            // portfolio while signed out (localStorage `portfolio_tickers` differs
            // from the demo default), push it up so it BECOMES the account's
            // portfolio — otherwise the signed-out work is lost on the next device
            // or login. Mirrors the anon-watchlist migration (app-init.ts ~3528) and
            // reuses savePortfolioTickers(), which POSTs to /api/portfolio/sync-tickers
            // when authed. _isDefaultPortfolio() guards against pushing an untouched
            // demo portfolio. Best-effort — never blocks boot.
            try {
                if (typeof PORTFOLIO_TICKERS !== 'undefined'
                    && typeof _isDefaultPortfolio === 'function' && !_isDefaultPortfolio()
                    && typeof savePortfolioTickers === 'function') {
                    savePortfolioTickers();
                    if (typeof showToast === 'function') {
                        showToast('Saved your portfolio to your account', 'success', 4000);
                    }
                }
            }
            catch (_e) { /* best-effort */ }
            return;
        }
        // Server wins: replace in-memory list and localStorage
        if (typeof PORTFOLIO_TICKERS !== 'undefined') {
            PORTFOLIO_TICKERS.length = 0;
            for (var i = 0; i < serverTickers.length; i++)
                PORTFOLIO_TICKERS.push(serverTickers[i]);
            OLStorage.set('portfolio_tickers', PORTFOLIO_TICKERS);
            if (typeof renderPortfolio === 'function')
                renderPortfolio();
        }
    })
        .catch(function () { });
}
// P2-14: Fetch server-side per-ticker scratchpad notes and seed localStorage.
// Server wins: if the server has a saved dict of {ticker: note}, populate each
// scratchpad_${ticker} key in localStorage. The existing _loadTickerNote() in
// ticker-renderer.js reads from localStorage first (instant), then hits the
// server — this pre-seeds localStorage so the first render is correct.
function _syncNotesFromServer() {
    fetch('/api/notes/sync', { credentials: 'include' })
        .then(function (r) { if (!r.ok)
        throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) {
        if (!data || data.notes === null || data.notes === undefined)
            return;
        if (typeof data.notes === 'object' && !Array.isArray(data.notes)) {
            // Dict of {ticker: noteText} — seed localStorage for each ticker
            var tickers = Object.keys(data.notes);
            for (var i = 0; i < tickers.length; i++) {
                var t = tickers[i];
                var noteText = data.notes[t];
                if (typeof noteText === 'string' && noteText) {
                    try {
                        OLStorage.setString('scratchpad_' + t, noteText);
                    }
                    catch (e) { }
                }
            }
        }
    })
        .catch(function () { });
}
// Tier wave 2026-09-24 item (b): the account dropdown named no plan. The
// label comes from the canonical accessor olTierLabel (app-init.ts, fed by the
// build-time OL_TIER_META from services/billing/constants.py) -- no tier name
// is spelled here. A '_trial' tier reads "<name> (trial)". An unknown tier, or
// olTierLabel not loaded yet, renders nothing rather than a guessed name.
function _authDropdownPlanLabel(tier) {
    if (typeof tier !== 'string' || !tier || tier === 'anonymous')
        return '';
    var isTrial = /_trial$/.test(tier);
    var key = tier.replace(/_trial$/, '');
    var name = (typeof olTierLabel === 'function' && olTierLabel(key)) || '';
    if (!name)
        return '';
    return 'Plan: ' + name + (isTrial ? ' (trial)' : '');
}
function _renderAuthDropdownPlan() {
    var el = document.getElementById('auth-dd-plan');
    if (!el)
        return;
    var label = _authUser ? _authDropdownPlanLabel(window._userTier) : '';
    // textContent, never innerHTML: the label is data (feedback_never_destroy_dom + escaping).
    el.textContent = label;
    if (label)
        el.classList.remove('hidden');
    else
        el.classList.add('hidden');
}
function authUpdateUI() {
    const btn = document.getElementById('auth-user-btn');
    const ddName = document.getElementById('auth-dd-name');
    const ddEmail = document.getElementById('auth-dd-email');
    const ddJoined = document.getElementById('auth-dd-joined');
    if (_authUser) {
        // CR-C4: dispatch ol-user-signed-in so session-lifecycle.js can restore
        // any drafts saved by the session-expiry handler before the modal appeared.
        try {
            window.dispatchEvent(new CustomEvent('ol-user-signed-in', { detail: { email: _authUser.email } }));
        }
        catch (_e) { }
        // P2-13/P2-14: pull server state once per session on login/session-restore
        if (!_serverSyncDone) {
            _serverSyncDone = true;
            _syncPortfolioTickersFromServer();
            _syncNotesFromServer();
        }
        // Show initials in button
        const initials = (_authUser.displayName || _authUser.email || '?')
            .split(/\s+/).map(w => w[0]).join('').toUpperCase().slice(0, 2);
        // OWNER + DESIGN 2026-07-20: icon-only account control — just the gold-circle
        // initials, no name label beside it (the full name stays on hover via title
        // + in the account dropdown). Consistent with the ghost-icon topstrip row.
        if (btn) {
            btn.innerHTML = '<span class="auth-initials">' + escHtml(initials) + '</span>';
            btn.classList.add('logged-in');
            btn.title = _authUser.displayName || _authUser.email;
        }
        // Populate dropdown
        if (ddName)
            ddName.textContent = _authUser.displayName || '';
        if (ddEmail)
            ddEmail.textContent = _authUser.email || '';
        _renderAuthDropdownPlan();
        if (ddJoined) {
            if (_authUser.createdAt) {
                const d = new Date(_authUser.createdAt);
                ddJoined.textContent = 'Member since ' + d.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
            }
            else {
                ddJoined.textContent = '';
            }
        }
        // Fetch billing data for status bar + dropdown
        fetchBillingData();
        // Resume checkout if user signed in from pricing page with upgrade intent.
        // 2026-04-29 mobile-UI Tier 4 (CISO P2 #6 — OWNER decision #2): require
        // an explicit confirm tap before progressing to Stripe. The shareable
        // `?signin=1&upgrade=<tier>` URL would otherwise let a malicious DM
        // trigger a paid-tier checkout flow with one tap on mobile (CSP
        // frame-ancestors blocks classic clickjacking but not URL-driven
        // social-engineering). Confirm gate breaks the auto-advance.
        try {
            const _intent = OLStorage.getSessionString('ol_upgrade_intent', null);
            if (_intent) {
                OLStorage.removeSession('ol_upgrade_intent');
                const parsed = JSON.parse(_intent);
                if (parsed.tier) {
                    // A1 (2026-05-13 Mobile/Brand/Billing audit follow-on):
                    // explicit tier allowlist + bail-out toast. The previous
                    // fall-through to `parsed.tier.charAt(0).toUpperCase() +
                    // slice(1)` rendered unrecognized slugs as "Plus_ai" in the
                    // native confirm() — leaking the broken-CTA bug to the user.
                    // Now an unknown slug shows a clear toast and skips checkout.
                    // 2.3 (2026-06-12): labels read the canonical accessor; the
                    // literals are the load-order fallback, pinned to the canon.
                    var _lbl = function (k, fb) {
                        return (typeof olTierLabel === 'function' && olTierLabel(k, true)) || fb;
                    };
                    var _tierLabels = {
                        plus: _lbl('plus', 'Researcher ($9/mo)'),
                        pro: _lbl('pro', 'Investor ($19/mo)'),
                        'pro-ai': _lbl('pro-ai', 'Power User ($29/mo)'),
                        professional: _lbl('professional', 'Power User ($29/mo)')
                    };
                    var _tierDisplay = _tierLabels[parsed.tier];
                    if (!_tierDisplay) {
                        if (typeof showToast === 'function') {
                            showToast('Tier not recognized — please re-select on the pricing page.', '', 5000);
                        }
                        return;
                    }
                    var _periodLabel = parsed.period === 'annual' ? 'annual' : 'monthly';
                    setTimeout(function () {
                        // F-05 (2026-05-21 external code review): kill the native
                        // window.confirm() before checkout. The user has already
                        // clicked "Upgrade" on /pricing — adding a confirmation
                        // step is friction that converts negatively (every payment-
                        // funnel best-practice guide flags this anti-pattern; the
                        // original comment at this site even acknowledged the
                        // "leaking the broken-CTA bug to the user" issue).
                        // Replaced with a non-blocking toast so the user gets
                        // immediate feedback that the click registered + checkout
                        // is loading, without a phishing-looking dialog.
                        if (typeof showToast === 'function') {
                            showToast('Opening checkout for ' + _tierDisplay + ' (' + _periodLabel + ')…', '', 2500);
                        }
                        _startCheckout(parsed.tier, parsed.period);
                    }, 600);
                }
            }
        }
        catch (_intentErr) { }
        // Show billing link in dropdown
        const billingBtn = document.getElementById('auth-dd-billing-btn');
        if (billingBtn)
            billingBtn.classList.remove('hidden');
        // (#121/CHAMP-6.7 2026-07-26: dead writes to #mobile-nav-signin and
        // .ol-topstrip-b-signin excised — both elements left the markup with
        // the hamburger cluster; the auth-user-btn is the canonical entry.)
        // Sync window._olCurrentUser so brand-v2-status.js shows the
        // signed-in account block (vs. the anonymous "Sign in →" CTA).
        try {
            window._olCurrentUser = {
                email: _authUser.email,
                username: _authUser.displayName,
                name: _authUser.displayName,
                tier: window._userTier || 'free'
            };
            // brand-v2-status.js exposes the toggle helper but only re-runs on
            // an interval (chrome=b) or on view change. Force a sync now so the
            // Settings panel reflects the new auth state immediately.
            var _anonBlk = document.getElementById('ol-settings-account-anon');
            var _userBlk = document.getElementById('ol-settings-account-user');
            var _nameEl = document.getElementById('ol-settings-account-name');
            var _emailEl = document.getElementById('ol-settings-account-email');
            var _tierEl = document.getElementById('ol-settings-account-tier');
            if (_anonBlk)
                _anonBlk.classList.add('hidden');
            if (_userBlk)
                _userBlk.classList.remove('hidden');
            if (_nameEl)
                _nameEl.textContent = _authUser.displayName || (_authUser.email || '').split('@')[0];
            if (_emailEl)
                _emailEl.textContent = _authUser.email || '';
            if (_tierEl)
                _tierEl.textContent = (window._userTier || 'free').toUpperCase().replace('_', ' + ');
        }
        catch (_e) { }
    }
    else {
        // Reset to generic user icon
        if (btn) {
            btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>';
            btn.classList.remove('logged-in');
            btn.title = 'Sign in';
        }
        if (ddName)
            ddName.textContent = '';
        if (ddEmail)
            ddEmail.textContent = '';
        if (ddJoined)
            ddJoined.textContent = '';
        _renderAuthDropdownPlan();
        // Hide billing link, portal link, and status bar counter
        const billingBtn = document.getElementById('auth-dd-billing-btn');
        if (billingBtn)
            billingBtn.classList.add('hidden');
        const portalBtn = document.getElementById('auth-dd-portal-btn');
        if (portalBtn)
            portalBtn.classList.add('hidden');
        _billingData = null;
        _updateStatusBarUsage(null);
        _updateAuthDropdownCap(null);
        // (#121: dead sign-in-element resets excised — see the authed branch.)
        // Clear window._olCurrentUser + restore Settings panel anon block.
        try {
            window._olCurrentUser = null;
            var _anonBlk2 = document.getElementById('ol-settings-account-anon');
            var _userBlk2 = document.getElementById('ol-settings-account-user');
            if (_anonBlk2)
                _anonBlk2.classList.remove('hidden');
            if (_userBlk2)
                _userBlk2.classList.add('hidden');
        }
        catch (_e) { }
    }
}
// 2026-05-06 P0 hotfix: defensive call. The original
// `window.OLApi.getAuthMe()` raised TypeError when OLApi wasn't
// registered yet — the api-client module loads via `<script
// type="module" defer>` while milestones-view loads via
// `<script defer>` (classic). Classic-defer scripts execute BEFORE
// modules, so authCheckSession() at module top-level (line 2053)
// fired before window.OLApi existed. The TypeError was caught
// silently below, no /api/auth/me request was made, and every
// page-load showed the auth modal because _authUser stayed null.
//
// Fix: try OLApi.getAuthMe; if unavailable, fall back to a direct
// same-origin fetch. Either path returns the same {authenticated,
// user, tier, csrf_token, ...} envelope.
async function _authMeFetchSafe() {
    try {
        if (typeof window.OLApi !== 'undefined' && typeof window.OLApi.getAuthMe === 'function') {
            return await window.OLApi.getAuthMe();
        }
    }
    catch (_e) { /* fall through to direct fetch */ }
    // Direct fallback — same-origin, includes session cookie. The
    // typed wrapper window.OLApi.getAuthMe is the preferred path
    // (lint rule ol/prefer-typed-api-client), but at module-top-level
    // load time it may not be registered yet (api-client.js loads as
    // a deferred ES module which executes AFTER classic-defer
    // bundle-app.min.js — see commit b74549eb root-cause analysis).
    // This direct fetch is the cold-start fallback ONLY; once OLApi
    // registers, subsequent calls (5-min interval, etc.) prefer it.
    // eslint-disable-next-line ol/prefer-typed-api-client -- load-order fallback for cold-start authCheckSession before api-client module registers OLApi; timeout-bounded (P1-2)
    const res = await fetch('/api/auth/me', { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
    if (!res.ok)
        throw new Error('HTTP ' + res.status);
    return await res.json();
}
async function authCheckSession() {
    try {
        const data = await _authMeFetchSafe();
        if (data) {
            if (data.csrf_token)
                _setCsrfToken(data.csrf_token);
            // Phase 1: detect tier transitions and dispatch ol-tier-changed so
            // TierGate + premium-gate can re-evaluate without a page reload.
            var _prevTier = window._userTier;
            // 2026-09-26: the anonymous /api/auth/me answer carries no `tier`, so
            // _userTier stayed undefined for a signed-out reader and every
            // `_userTier === 'anonymous'` gate (the LEARN hero/sign-up invite, the
            // lesson deep-link panel, ~15 sites) never fired. Name the state here,
            // where the answer arrives; the dispatch below re-renders the gates.
            // (A local, not a write to `data`: that object may be the shared
            // getAuthMe cache entry other modules read.)
            var _tier = data.tier || (data.authenticated === false ? 'anonymous' : '');
            // Hydrate tier + trial globals for premium-gate.js
            if (_tier)
                window._userTier = _tier;
            if (data && data.trial_active)
                window._trialActive = true;
            if (data && typeof data.trial_days_remaining === 'number')
                window._trialDaysRemaining = data.trial_days_remaining;
            if (_tier && _tier !== _prevTier) {
                try {
                    window.dispatchEvent(new CustomEvent('ol-tier-changed', { detail: { tier: _tier, previous: _prevTier } }));
                }
                catch (_) { }
            }
            if (data && data.authenticated && data.user) {
                // Flatten user fields to top level for UI compatibility
                _authUser = Object.assign({}, data, data.user);
                authUpdateUI();
            }
            else if (data && data.email) {
                // Legacy format: email at top level
                _authUser = data;
                authUpdateUI();
            }
            // ROADMAP P2 (2026-04-24): TERMS_VERSION re-acceptance modal.
            // Backend ships `terms_reacceptance_required: true` on
            // /api/auth/me when the user's stored terms_version differs
            // from OL_TERMS_VERSION. Show a blocking modal until they
            // re-accept. Skipped for unauthenticated sessions (the
            // current-user query short-circuits server-side).
            if (data && data.authenticated && data.terms_reacceptance_required) {
                try {
                    _showTermsReacceptanceModal(data);
                }
                catch (_) { }
            }
            if (data && data.authenticated && data.consent_status === 'needed') {
                try {
                    _olShowConsentNotice();
                }
                catch (_) { }
            }
        }
    }
    catch (_) { /* not logged in or server down */ }
}
// OWNER 2026-10-03: a 13-17 account whose parent has not approved, and who
// has no live approval link (/api/auth/me consent_status === 'needed'), sees
// this notice. Nothing is emailed proactively; the button re-sends to the
// address on file through POST /api/user/parental-consent {resend: true}.
// Built with the dunning banner's classes (static/css/dunning-banner.css).
function _olShowConsentNotice() {
    if (document.getElementById('ol-consent-notice'))
        return;
    var bar = document.createElement('div');
    bar.id = 'ol-consent-notice';
    bar.className = 'ol-dunning-banner';
    bar.setAttribute('role', 'status');
    var text = document.createElement('span');
    text.className = 'ol-dunning-text';
    text.textContent = 'Your parent or guardian hasn’t confirmed your account yet. Send them the request again.';
    // CHAOS F9 (2026-10-04): no "ask them to check their email" -- the notice
    // shows only when no live approval link exists (consent_status 'needed'),
    // and the cohort it exists for was never emailed at all.
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ol-dunning-cta';
    btn.textContent = 'Send the request again';
    btn.addEventListener('click', function () {
        btn.disabled = true;
        var headers = (typeof _csrfHeaders === 'function') ? _csrfHeaders() : {};
        headers['Content-Type'] = 'application/json';
        fetch('/api/user/parental-consent', {
            method: 'POST', credentials: 'same-origin', headers: headers,
            body: JSON.stringify({ resend: true })
        }).then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (d) {
                if (r.ok) {
                    bar.remove();
                    if (typeof showToast === 'function')
                        showToast(d.message || 'Email sent to your parent or guardian.', 'success', 4000);
                }
                else {
                    btn.disabled = false;
                    if (typeof showToast === 'function')
                        showToast(d.error || 'We could not send the email. Please try again later.', 'error', 6000);
                }
            });
        }).catch(function () {
            btn.disabled = false;
            if (typeof showToast === 'function')
                showToast('We could not send the email. Please try again later.', 'error', 6000);
        });
    });
    bar.appendChild(text);
    bar.appendChild(btn);
    document.body.insertBefore(bar, document.body.firstChild);
}
// ── Terms re-acceptance modal (ROADMAP P2, 2026-04-24) ─────────────
// Self-contained: injects DOM + styles on first call, reuses on
// subsequent. Calls POST /api/auth/accept-terms on user accept,
// then re-runs authCheckSession() to clear the flag.
function _showTermsReacceptanceModal(authData) {
    // Idempotent — if the modal is already on screen, no-op.
    if (document.getElementById('terms-reacceptance-modal'))
        return;
    var current = (authData && authData.terms_version_current) || 'the current version';
    var prior = (authData && authData.terms_version_user) || '(none on record)';
    var overlay = document.createElement('div');
    overlay.id = 'terms-reacceptance-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'terms-reacc-title');
    overlay.className = 'tr-modal-overlay';
    // Inner card. Classes defined in oxford.css under /* CSP-A1: Terms re-acceptance modal classes */
    // so they are available regardless of which CSS bundle has loaded.
    var card = document.createElement('div');
    card.className = 'tr-modal-card';
    card.innerHTML = ('<h2 id="terms-reacc-title" class="tr-modal-title">' +
        'Updated Terms of Service' +
        '</h2>' +
        '<p class="tr-modal-body">' +
        'We\u2019ve updated our Terms of Service. To continue using Oxford ' +
        'Ledge, please review and accept the latest version.' +
        '</p>' +
        '<div class="tr-modal-version-box">' +
        '<div><strong>Current version:</strong> <code>' + _escHtmlTerms(String(current)) + '</code></div>' +
        '<div><strong>You accepted:</strong> <code>' + _escHtmlTerms(String(prior)) + '</code></div>' +
        '</div>' +
        '<p class="tr-modal-terms-body">' +
        'You can read the full terms at <a href="/terms" target="_blank" ' +
        'rel="noopener" class="tr-modal-terms-link">' +
        '/terms</a>.' +
        '</p>' +
        '<button id="terms-reacc-accept" type="button" class="tr-modal-accept-btn">' +
        'I accept the updated terms' +
        '</button>' +
        '<div id="terms-reacc-error" class="tr-modal-error"></div>');
    overlay.appendChild(card);
    document.body.appendChild(overlay);
    // Wire up the button
    var btn = document.getElementById('terms-reacc-accept');
    var errEl = document.getElementById('terms-reacc-error');
    btn.addEventListener('click', function () {
        btn.disabled = true;
        btn.textContent = 'Recording acceptance\u2026';
        errEl.classList.remove('is-visible');
        var csrf = (typeof _getCsrfToken === 'function') ? _getCsrfToken() : '';
        fetch('/api/auth/accept-terms', {
            method: 'POST',
            credentials: 'same-origin',
            headers: csrf ? { 'X-CSRF-Token': csrf } : {},
        }).then(function (r) {
            if (!r.ok)
                throw new Error('HTTP ' + r.status);
            return r.json();
        }).then(function (_resp) {
            // Success — remove modal + refresh auth state so the flag
            // clears for any other consumer.
            overlay.remove();
            if (typeof authCheckSession === 'function') {
                try {
                    authCheckSession();
                }
                catch (_) { }
            }
            if (typeof showToast === 'function') {
                try {
                    showToast('Thanks for accepting the updated terms.', 'success', 3000);
                }
                catch (_) { }
            }
        }).catch(function (e) {
            btn.disabled = false;
            btn.textContent = 'I accept the updated terms';
            errEl.textContent = 'Something went wrong recording your acceptance. Please try again. (' + (e && e.message || 'unknown') + ')';
            errEl.classList.add('is-visible');
        });
    });
}
function _escHtmlTerms(s) {
    if (s == null)
        return '';
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
// ── S4 (mobile/tablet audit 2026-09-25): the "Forgot password?" pane ──
// POST /api/auth/forgot-password and /api/auth/reset-password have existed
// since S38, but nothing on any page reached the first one, and the emailed
// link (/reset-password?token=...) 404'd because no page route served it.
// This is the first half: email -> POST forgot-password -> ONE neutral
// sentence whatever the server found. The server answers 200 whether or not
// the address has an account (enumeration guard), and the client must not
// undo that by wording. The second half is templates/reset-password.html +
// static/js/reset-password.ts. Pinned by
// tests/test_auth_password_reset_surface_contract.py.
var AUTH_FORGOT_NEUTRAL_COPY = 'If that address has an account, we sent a link to choose a new password. The link works for one hour.';
function authOpenForgot() {
    if (!document.getElementById('auth-form-forgot'))
        return;
    authSwitchTab('forgot');
    var _done = document.getElementById('auth-forgot-done');
    if (_done) {
        _done.classList.add('d-none');
        _done.textContent = '';
    }
    var _signinEmail = document.getElementById('auth-signin-email');
    var _forgotEmail = document.getElementById('auth-forgot-email');
    // Carry a half-typed sign-in email across so the user does not retype it.
    if (_forgotEmail && _signinEmail && _signinEmail.value && !_forgotEmail.value)
        _forgotEmail.value = _signinEmail.value;
    setTimeout(function () { if (_forgotEmail)
        _forgotEmail.focus(); }, 50);
}
async function authSubmitForgot(e) {
    if (e && e.preventDefault)
        e.preventDefault();
    var btn = document.getElementById('auth-forgot-btn');
    var errEl = document.getElementById('auth-err-forgot');
    var doneEl = document.getElementById('auth-forgot-done');
    var emailEl = document.getElementById('auth-forgot-email');
    var email = (emailEl && emailEl.value ? emailEl.value : '').trim();
    if (!email || email.indexOf('@') === -1) {
        if (errEl) {
            errEl.textContent = 'Please enter your email address.';
            errEl.classList.add('visible');
        }
        if (emailEl)
            emailEl.focus();
        return;
    }
    if (errEl)
        errEl.classList.remove('visible');
    if (btn) {
        btn.disabled = true;
        btn.textContent = 'Sending…';
    }
    try {
        var res = await fetch('/api/auth/forgot-password', {
            method: 'POST', headers: _csrfHeaders(), credentials: 'same-origin',
            body: JSON.stringify({ email: email })
        });
        if (res.status === 429) {
            if (errEl) {
                errEl.textContent = 'Too many requests. Please wait a few minutes and try again.';
                errEl.classList.add('visible');
            }
            return;
        }
        if (!res.ok) {
            // A transport or CSRF failure is not an "account exists" signal either
            // way; it is a retry, never the neutral sentence (nothing was sent).
            if (errEl) {
                errEl.textContent = 'Something went wrong on our side. Please try again.';
                errEl.classList.add('visible');
            }
            return;
        }
        if (doneEl) {
            doneEl.textContent = AUTH_FORGOT_NEUTRAL_COPY;
            doneEl.classList.remove('d-none');
        }
    }
    catch (_err) {
        if (errEl) {
            errEl.textContent = 'We couldn’t reach Oxford Ledge. Please try again — if it keeps happening, check your network.';
            errEl.classList.add('visible');
        }
    }
    finally {
        if (btn) {
            btn.disabled = false;
            btn.textContent = 'Send reset link';
        }
    }
}
// ── S2 (mobile audit 2026-09-25): the "Check your inbox" pane ──
// Shown after an email sign-up that needs its address confirmed. The resend
// goes to the EXISTING endpoint with its existing posture: CSRF header
// (_csrfHeaders), the server's per-(IP, email) limit of 3 an hour plus the
// auth_resend middleware bucket, and a neutral answer whatever the account
// state -- so this pane words the result the same neutral way and never says
// whether the address has an account. A 30-second client cool-down keeps a
// double tap from spending the hourly allowance.
var AUTH_INBOX_RESENT_COPY = 'If that address still needs confirming, we sent a new link. It can take a minute or two to arrive.';
var AUTH_INBOX_COOLDOWN_MS = 30000;
var _authInboxEmail = '';
function authShowCheckInbox(email) {
    var pane = document.getElementById('auth-form-inbox');
    var addr = document.getElementById('auth-inbox-address');
    if (!pane || !addr)
        return false;
    _authInboxEmail = String(email || '').trim();
    addr.textContent = _authInboxEmail;
    var status = document.getElementById('auth-inbox-status');
    if (status) {
        status.textContent = '';
        status.classList.add('d-none');
    }
    var rb = document.getElementById('auth-inbox-resend');
    if (rb) {
        rb.disabled = false;
        rb.textContent = 'Resend the link';
    }
    authSwitchTab('inbox');
    setTimeout(function () { if (rb)
        rb.focus(); }, 50);
    return true;
}
async function authResendFromInbox() {
    var rb = document.getElementById('auth-inbox-resend');
    var status = document.getElementById('auth-inbox-status');
    if (!_authInboxEmail || (rb && rb.disabled))
        return;
    if (rb) {
        rb.disabled = true;
        rb.textContent = 'Sending…';
    }
    var _say = function (msg) { if (status) {
        status.textContent = msg;
        status.classList.remove('d-none');
    } };
    var cooled = false;
    try {
        var res = await fetch('/api/auth/resend-verify', {
            method: 'POST', headers: _csrfHeaders(), credentials: 'same-origin',
            body: JSON.stringify({ email: _authInboxEmail })
        });
        if (res.status === 429) {
            _say('Too many requests. Please wait a few minutes and try again.');
            cooled = true;
            return;
        }
        if (!res.ok) {
            _say('Something went wrong on our side. Please try again.');
            return;
        }
        _say(AUTH_INBOX_RESENT_COPY);
        cooled = true;
    }
    catch (_err) {
        _say('We couldn’t reach Oxford Ledge. Please try again — if it keeps happening, check your network.');
    }
    finally {
        if (rb) {
            rb.textContent = 'Resend the link';
            if (cooled)
                setTimeout(function () { rb.disabled = false; }, AUTH_INBOX_COOLDOWN_MS);
            else
                rb.disabled = false;
        }
    }
}
function authInboxUseDifferentEmail() {
    authSwitchTab('register');
    var em = document.getElementById('auth-reg-email');
    if (em) {
        em.value = '';
        setTimeout(function () { em.focus(); }, 50);
    }
}
document.addEventListener('click', function (e) {
    var _t = e.target;
    var _el = (_t && typeof _t.closest === 'function') ? _t.closest('[data-auth-action="inbox-resend"], [data-auth-action="inbox-change"]') : null;
    if (!_el)
        return;
    e.preventDefault();
    if (_el.getAttribute('data-auth-action') === 'inbox-resend')
        authResendFromInbox();
    else
        authInboxUseDifferentEmail();
});
// The modal is materialized lazily (_materializeView), so both hooks are
// document-level delegation rather than element listeners. The link carries
// `data-auth-action` rather than `data-action`: the central dispatcher in
// app-renderers.ts warns "No handler for" every data-action it does not own,
// and this one is owned here, in the pre-bundle auth chunk.
document.addEventListener('click', function (e) {
    var _t = e.target;
    var _el = (_t && typeof _t.closest === 'function') ? _t.closest('[data-auth-action="forgot-open"]') : null;
    if (!_el)
        return;
    e.preventDefault();
    authOpenForgot();
});
document.addEventListener('submit', function (e) {
    var _f = e.target;
    if (_f && _f.id === 'auth-form-forgot')
        authSubmitForgot(e);
});
// Close auth dropdown on outside click
document.addEventListener('click', function (e) {
    const dd = document.getElementById('auth-dropdown');
    const btn = document.getElementById('auth-user-btn');
    if (dd && dd.classList.contains('open') && !dd.contains(e.target) && e.target !== btn && !(btn && btn.contains(e.target))) {
        dd.classList.remove('open');
    }
});
// Re-label the dropdown's plan line when the tier changes in-session
// (checkout return, trial expiry, sign-out).
window.addEventListener('ol-tier-changed', function () { _renderAuthDropdownPlan(); });
// Close auth modal on overlay click
document.getElementById('auth-modal-overlay')?.addEventListener('click', function (e) {
    if (e.target === this)
        authCloseModal();
});
// Check session on load + periodic re-check every 5 minutes
authCheckSession();
setInterval(function () {
    if (!_authUser)
        return; // Only re-check if we think we're logged in
    // #22 (audit 2026-06-18): skip the /api/auth/me re-check when the tab is
    // backgrounded — this 5-min global poller had no visibility guard. Stays a
    // setInterval by design (global, must run across all views — kept OUT of
    // OLPolling's 3-slot cap so it can't starve the view-data polls).
    if (typeof document !== 'undefined' && document.hidden)
        return;
    // 2026-05-06 P0 hotfix: same defensive shim as authCheckSession.
    // window.OLApi could in theory be undefined here too; use the
    // shared fallback-aware fetcher.
    _authMeFetchSafe()
        .then(function (d) {
        if (!d.authenticated && _authUser) {
            // Session expired — update UI
            _authUser = null;
            authUpdateUI();
            if (typeof showToast === 'function')
                showToast('Your session has expired. Please sign in again.', '', 5000);
        }
    })
        .catch(function () { });
}, 300000); // 5 minutes
// B14 (2026-09-25): ask the server what Stripe says about the Checkout Session
// the browser came back with, and say only what that answer supports.
function _confirmCheckoutSession(sid) {
    // eslint-disable-next-line ol/prefer-typed-api-client -- one-shot post-return reconcile; the route is new and not yet in the generated client
    return fetch('/api/billing/checkout-status?session_id=' + encodeURIComponent(sid), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (s) {
        if (s && s.paid === true) {
            showToast('Payment successful! Your plan has been upgraded.', 'success', 5000);
            if (typeof fetchBillingData === 'function')
                fetchBillingData();
        }
        else if (s && s.status === 'complete') {
            showToast('Your payment is processing. Your plan will update as soon as it clears.', 'info', 8000);
        }
        else {
            showToast("We couldn’t confirm your payment. If you were charged, your plan will update shortly; otherwise try again from Settings.", 'warning', 8000);
        }
    })
        .catch(function () {
        showToast("We couldn’t confirm your payment yet. Please refresh in a minute.", 'warning', 8000);
    });
}
// P1-17 (external review 2026-09-26): the pre-checkout tier used to be read
// when this file LOADED -- before /api/auth/me had answered, so it was always
// the empty default and the poller compared against 'free'. A reader moving
// from one paid tier to a higher one then saw "Payment successful! Your plan
// has been upgraded" on the first poll, before the webhook had changed
// anything. Read it from the RESOLVED auth state instead: the global when
// authCheckSession has already set it, else one /api/auth/me read. '' when
// unknown.
function _checkoutPriorTier() {
    var t = window._userTier;
    if (typeof t === 'string' && t)
        return Promise.resolve(t);
    return _authMeFetchSafe()
        .then(function (d) { return (d && (d.tier || (d.authenticated === false ? 'anonymous' : ''))) || ''; })
        .catch(function () { return ''; });
}
function _runCheckoutReturn(_sid) {
    // Show "Activating your subscription…" while polling.
    var _lifecycle = window.OLSessionLifecycle;
    if (_lifecycle && typeof _lifecycle._showInfoToast === 'function') {
        _lifecycle._showInfoToast('Activating your subscription…');
    }
    else {
        showToast('Activating your subscription…', '', 0); // persistent until resolved
    }
    var _hideInfo = function () {
        if (_lifecycle && typeof _lifecycle._hideInfoToast === 'function') {
            _lifecycle._hideInfoToast();
        }
    };
    return _checkoutPriorTier().then(function (_priorTier) {
        if (!_priorTier && _sid) {
            // No known starting tier means a tier change cannot be told from no
            // change at all: ask Stripe instead of polling against a guess.
            _hideInfo();
            return _confirmCheckoutSession(_sid);
        }
        // Poll /api/auth/refresh-tier up to 10× at 1s intervals.
        var _poll = _lifecycle && typeof _lifecycle.pollTierRefresh === 'function'
            ? _lifecycle.pollTierRefresh({ maxAttempts: 10, intervalMs: 1000, priorTier: _priorTier || 'free' })
            : Promise.reject({ reason: 'lifecycle_unavailable' });
        return _poll.then(function (result) {
            // Tier changed — hide the "activating" banner, show success.
            _hideInfo();
            showToast('Payment successful! Your plan has been upgraded.', 'success', 5000);
            // Re-fetch billing data to refresh the credit indicator + usage panels.
            if (typeof fetchBillingData === 'function')
                fetchBillingData();
            // Dispatch view-refresh so any open tier-gated panels re-render
            // (tier-gate.ts OL-TIER-RISE-REFRESH re-runs the current view).
            try {
                window.dispatchEvent(new CustomEvent('ol-view-refresh', {
                    detail: { reason: 'tier-upgraded', oldTier: result.oldTier, newTier: result.newTier }
                }));
            }
            catch (_e) { }
        }).catch(function (err) {
            // Timeout or network error — hide the banner, show a fallback prompt.
            _hideInfo();
            if (_sid) {
                // B14 (2026-09-25): never announce success on a failed poll without
                // asking. The server confirms the Session belongs to this user;
                // `status === 'complete'` with `paid === false` is a bank debit
                // still processing, not a failure (CHAOS 2026-09-25 checkout review).
                // A TIMEOUT asks too (2026-09-26): with the prior tier now read after
                // auth resolves, a webhook that landed first leaves nothing for the
                // poller to see change, and Stripe is the one that knows.
                return _confirmCheckoutSession(_sid);
            }
            if (err && err.reason === 'timeout') {
                // Webhook is still processing — give the user a non-alarming prompt.
                showToast("We’re processing your upgrade — please refresh in a minute. " +
                    '<button type="button" data-action="page-reload" class="ol-session-toast-signin-btn ol-session-toast-signin-btn--inline-retry">Retry</button>', 'warning', 0, // persistent
                { html: true });
            }
            else {
                showToast("We couldn’t confirm your payment. Please refresh in a minute.", 'warning', 8000);
            }
        });
    });
}
// Handle billing redirect query params from Stripe Checkout
// CR-H5 (2026-04-30): replaced the naive "show success toast + fetchBillingData()"
// with a tier-refresh polling loop so the user sees their upgraded tier as soon
// as the Stripe webhook processes (typically 2–5s) rather than staring at the
// free-tier paywall on return.
(function () {
    var params = new URLSearchParams(window.location.search);
    if (params.get('billing') === 'success') {
        // B14 (2026-09-25): Checkout's success_url carries the Session id; read it
        // before the query is stripped so a failed poll can ask Stripe, via
        // /api/billing/checkout-status, instead of guessing "successful".
        var _sid = params.get('session_id');
        window.history.replaceState({}, '', window.location.pathname);
        setTimeout(function () { _runCheckoutReturn(_sid); }, 500);
    }
    else if (params.get('billing') === 'cancel') {
        setTimeout(function () {
            showToast('Checkout cancelled. No charges were made.', '', 4000);
        }, 500);
        window.history.replaceState({}, '', window.location.pathname);
    }
    else if (params.get('signin') === '1') {
        // Redirected from pricing page -- open sign-in modal, then start checkout after auth
        var upgradeTier = params.get('upgrade');
        var upgradePeriod = params.get('period') || 'monthly';
        window.history.replaceState({}, '', window.location.pathname);
        setTimeout(function () {
            if (typeof authToggle === 'function')
                authToggle();
            if (upgradeTier) {
                showToast('Sign in to subscribe to ' + upgradeTier.charAt(0).toUpperCase() + upgradeTier.slice(1), '', 4000);
                // Store upgrade intent so we can resume after login
                // eslint-disable-next-line ol/no-direct-localstorage -- sessionStorage intent-store; no OLStorage wrapper exists for cross-module upgrade-resume; matches the established pattern at app.js:2943
                sessionStorage.setItem('ol_upgrade_intent', JSON.stringify({ tier: upgradeTier, period: upgradePeriod }));
            }
        }, 300);
    }
})();
//# sourceMappingURL=auth-handlers.js.map
;